
import { AuthStepsEnum, SubscriptionPlan, PaywallPlans, SiteLinks, CustomerAccessData } from "../../../../global/paywall/paywallInterfaces";
import { getAuthHookFactory } from "../../../../global/paywall/useAuth";
import { PremiumPaywallDesktopSignupEmail } from "./signup/premiumPaywallDesktopSignupEmail"
import { PremiumPaywallDesktopSignupPassword } from "./signup/premiumPaywallDesktopSignupPassword"
import { PremiumPaywallState } from "./premiumPaywallDesktop";
import PremiumPaywallCheckoutPlans from "./premiumPaywallPlans";


interface PremiumPaywallDesktopSignupProps {
  email: string
  password: string
  agreesTerms: boolean
  setEmail: (email: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  setIsRedirecting: (isRedirect: boolean) => void
  handleSelectPlan?: (selectedPlan: string | null) => void
}



declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}


export const PremiumPaywallDesktopSignup = (props: PremiumPaywallDesktopSignupProps) => {

  const { email, setEmail, password, setPassword, setMode, agreesTerms, setAgreesTerms, setIsRedirecting,handleSelectPlan} = props

  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailForLogin,
    submitPassword,
    resetAuth,
    handleChoosePlan
  } = getAuthHookFactory("signup", AuthStepsEnum.PLANS)();

  const sendMail = () => {
    sendEmailForLogin(email, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onReset = () => {
    resetAuth()
    setAgreesTerms(false)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }



  switch (step) {
    case AuthStepsEnum.PLANS:
      return (
        <PremiumPaywallCheckoutPlans
          handleSelectPlan={handleSelectPlan}
          setMode={setMode}
          setIsRedirecting={setIsRedirecting}
          handleChoosePlan={handleChoosePlan}
        />)

    case AuthStepsEnum.EMAIL:
      return (
        <PremiumPaywallDesktopSignupEmail
          email={email}
          agreesTerms={agreesTerms}
          setEmail={setEmail}
          setAgreesTerms={setAgreesTerms}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumPaywallDesktopSignupPassword
          email={email}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          onBack={onReset}
          sendMail={sendMail}
          authError={authError}
        />
      )

    // case AuthStepsEnum.CONFIRM_TERMS:
    //   return (
    //     <PremiumPaywallDesktopSignupConfirmTerms
    //       resetAuth={onReset}
    //       thirdPartyLogin={onThirdPartyLogin}

    //     />
    //   )

    case AuthStepsEnum.FINISH:
      setIsRedirecting(true);
      return null;
    default:
      return null
  }
};
